import * as React from 'react';
import { CurrentUserDto } from '../../../../../../types/UserDtos';
import Link from '../../../../components/Link';
import replacement from '../../../../services/Replacement';

type Props = {
    user: CurrentUserDto;
};

const Logo: React.FC<Props> = ({ user }) => {
    const { companyLogoId } = user.company.companyDesignSettings;
    const customLogoSrc = companyLogoId && `/imageservice?id=${companyLogoId}&crop=false&size=-1`;
    const customLogoAlt = user.company.name;
    const hasCustomCompanyName = replacement('header.companyName') !== 'Small Improvements';

    return (
        <Link
            className="app-header-logo"
            href="/app/home"
            aria-label="Small Improvements Home"
            eventTracking={{ category: 'navigation header', action: 'click logo' }}
            testId="home-link"
        >
            {!customLogoSrc && hasCustomCompanyName && (
                <div className="app-header-button-content">
                    <img
                        className="app-header-button-content-default"
                        src="/images/logo/2020/si-logomark-color.svg"
                        alt=""
                    />
                    <div className="app-header-button-label app-header-item-label">
                        {replacement('header.companyName')}
                    </div>
                </div>
            )}
            {!customLogoSrc && !hasCustomCompanyName && (
                <div className="app-header-button-content app-header-logo-logo-only">
                    <img
                        className="app-header-button-content-default app-header-logo-logo-only-icon"
                        src="/images/logo/2020/si-logomark-color.svg"
                        alt=""
                    />
                    <img
                        className="app-header-button-content-default app-header-logo-logo-only-full"
                        src="/images/logo/2020/si-logo-2lines-color.svg"
                        alt=""
                    />
                </div>
            )}
            {customLogoSrc && <img alt={customLogoAlt} className="app-header-logo-custom" src={customLogoSrc} />}
        </Link>
    );
};

export default Logo;
